import type {
  ApiEnvironment,
  ApiUser,
} from '#/api/userEnvironment/types/ApiUserEnvironment';
import type { AppConstants } from '#/config/appConstants';
import type { AppConfig } from '#/config/types/AppConfig';
import type { I18nLocale } from '#/i18n/types/I18nLocale';

type Props = {
  locale: I18nLocale;
  user: ApiUser | null;
  environment: ApiEnvironment;
  appConfig: AppConfig;
  appConstants: AppConstants;
};

export function HorizonSetIdealistObjectScript({
  locale,
  user,
  environment,
  appConfig,
  appConstants,
}: Props) {
  const idealistObject = {
    locale,
    initUserEnvironment: { user, environment },
    config: appConfig,
    appConstants,
  } satisfies typeof Idealist;

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: [
          `window.Idealist = ${JSON.stringify(idealistObject)};`,
          'window.dataLayer = window.dataLayer || [];',
        ].join(''),
      }}
    />
  );
}
